import './App.css';

// Import Routes
import React from 'react';
import { Route, Routes } from "react-router-dom";
import Home from './routes/Home';
import Projects from './routes/Projects';
import About from './routes/About';

function App() {
  return (
    <div className="App">
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path='/about' element={<About />} />
        <Route path='/projects' element={<Projects />} />
      </Routes>
    </div>
  );
}

export default App;
